import React from "react";

import {
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
} from "@material-ui/core";
import { EmojiEmotions, ThumbUpSharp, AttachMoney, PeopleAlt } from "@material-ui/icons";

export function Overview(props) {
  const { data } = props;
  const overviewData = [
    {
      icon: <EmojiEmotions fontSize={"large"} color="primary"/>,
      title: "Student Enrolled",
      value: data.enrolledStudents ? data.enrolledStudents : '--',
    },
    {
        icon: <ThumbUpSharp fontSize={"large"} color="primary"/>,
        title: "Acceptance Rate",
        value: data.acceptanceRate ? data.acceptanceRate : '--' 
    },
    {
        icon: <AttachMoney fontSize={"large"} color="primary"/>,
        title: "Average Costs",
        value: data.avgCostOfAttendance ? data.avgCostOfAttendance : '--'
    },
    {
        icon: <PeopleAlt fontSize={"large"} color="primary"/>,
        title: "Student Faculty Ratio",
        value: data.studentFacultyRatio ? data.studentFacultyRatio : '--'
    }
  ];
  
  return (
    <>
      <Card>
        <CardContent>
          <Typography gutterBottom variant="h5">
            Overview
          </Typography>
          <List>
            {overviewData.map((item, index) => (
              <ListItem key={index}>
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText>
                  <Typography variant="h6">{item.title}</Typography>
                </ListItemText>
                <Box ml="auto">
                  <Typography variant="body1" style={{ fontWeight: "bold" }}>
                    {item.value}
                  </Typography>
                </Box>
              </ListItem>
            ))}
          </List>
        </CardContent>
      </Card>
    </>
  );
}
